module.exports =
  accepted: [String]
  value:    "#ffffff"
